import 'react-toastify/dist/ReactToastify.css';
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import {
  doListRewardPoint,
  doGetRewardPoint,
  doCreateRewardPoint,
  doUpdateRewardPoint,
  doDeleteRewardPoint
} from '../../services/reward.service';

export const onGetRewardPointList = createAsyncThunk("bookings/getRewardPointList", async () => {
  try {
    const response: any = await doListRewardPoint(0);
    return response;
  } catch (error) {
    return error;
  }
});

export const onGetRewardPointDetail = createAsyncThunk("bookings/getRewardPointDetail", async (pointHistoryId: string) => {
  try {
    const response: any = await doGetRewardPoint(pointHistoryId);
    return response;
  } catch (error) {
    return error;
  }
});

export const onAddRewardPoint = createAsyncThunk("bookings/addRewardPoint", async (params: any) => {
  try {
    const response = doCreateRewardPoint(params);
    const data = await response;
    toast.success("Point History Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Point History Added Failed", { autoClose: 2000 });
    return error;
  }
});

export const onUpdateRewardPoint = createAsyncThunk("bookings/updateRewardPoint", async (params: any) => {
  try {
    const response = doUpdateRewardPoint(params);
    const data = await response;
    toast.success("Point History updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("Point History updated Failed", { autoClose: 2000 });
    return error;
  }
});

export const onDeleteRewardPoint = createAsyncThunk("bookings/deleteRewardPoint", async (pointHistoryId: string) => {
  try {
    const response = doDeleteRewardPoint(pointHistoryId);
    toast.success("Point History deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("Point History deleted Failed", { autoClose: 2000 });
    return error;
  }
})
